window.addEventListener('load', () => {
    if (document.body) {
        document.body.classList.add('loaded');
    }
});